export const eventBadgeTemplate = (state) => state.eventBadgeTemplate